
import * as ActionTypes from './ActionTypes'
import { List, Map } from 'immutable'

const getInitialState = () => {
  return Map({
    'configurations': Map({}),
    'orders': Map({})
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNPPI_SET_CONFIGURATIONS:
      return state.set('configurations', Map(action.configs))
    case ActionTypes.VNPPI_SET_ORDER_PAYMENTS:
      return state.setIn(['orders', action.orderUuid, 'payments'], List(action.payload))
    default:
      return state
  }
}

export default reducer
